/**
 * eventCard.tsx
 */
import Card from '@shared/types/props/card';
import Colors from '@shared/assets/style/default/color';
import Event from '@shared/classes/event';
import HorizontalCard from './horizontalCard';
import { memo, useMemo } from 'react';

/**
 * Event card component.
 */
function EventCard(props: Card) {
  const item = props.item as Event;
  const progressBar = useMemo(() => {
    const currentEvent = item.isCurrentEvent() && !item.mocked;

    if (!currentEvent) {
      return null;
    }

    const progress = item.date ? Date.now() - item.date.start : undefined;
    const duration = item.date ? item.date.end - item.date.start : undefined;
    const percentage = Math.max(
      progress && duration ? (progress / duration) * 100 : 0,
      0
    );
    return {
      color: Colors.progress.fill,
      percentage: currentEvent && percentage > 0 ? percentage : 0,
    };
  }, [item]);

  return <HorizontalCard {...props} progressBar={progressBar} />;
}

export default memo(EventCard);
